import {RegisterForm} from '@/modules/auth/register/components'
import {Box, Container, Flex, Text} from '@chakra-ui/react'
import {createFileRoute} from '@tanstack/react-router'
import {useTranslate} from '@tolgee/react'

export const Route = createFileRoute('/auth/register')({
  component: RegisterPage,
})

function RegisterPage() {
  const {t} = useTranslate('auth')

  return (
    <Container maxWidth="22rem" padding="0">
      <Flex flexDirection="column" gapY="1.5rem">
        <Box>
          <Text as="h1" fontSize="2xl" fontWeight="bold" color="fg" fontFamily="heading">
            {t('welcome')}
          </Text>
          <Text as="h2" fontSize="md" color="fg.muted">
            {t('create_a_new_account')}
          </Text>
        </Box>

        <RegisterForm />
      </Flex>
    </Container>
  )
}
